// components/ForgotPasswordGuard.js
import React from 'react';
import { Navigate } from 'react-router-dom';

const ForgotPasswordGuard = ({ children }) => {
    const hasForgotPasswordData = sessionStorage.getItem('forgot-password-data');
    return hasForgotPasswordData ? children : <Navigate to="/login" replace />;
};

export default ForgotPasswordGuard;
